import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import DynamicFont from "react-dynamic-font";
import { CusButton } from "../../Components/From/Button";
import { AsyncModel } from "../AsyncModel/AsyncModel";
import { Global } from "../../App";
import Tool_mealListWithoutSplit from "../Tools/Tool_mealListWithoutSplit";
import Tool_mealListWithoutSplit_staff from "../Tools/Tool_mealListWithoutSplit_staff"
import Tool_CusSp from "../../Components/Tools/Tool_CusSp";
import _ from "lodash";
import moment from "moment";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";
// api
import {
  getSecificProduct,
  postOrderEditProduct,
} from "../../Api/staff/GetSecificProduct";

/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 *
 * currentStep (3.1 => 3 )
 * mealDetail
 * mealOrderDetail
 *
 */

function OrderStep_3_mealInfo(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    skipInit: true,
    productData: null,
    isAddNew: false,
    currModify: {},
    specPopupSetting: {
      toggle: false,
      productName: "",
      specName: "",
      dineInTaste: [],
      takeoutTaste: [],
      disableTakeoutState: false,
    },
  });

  async function apiSecificProduct(
    orderCode,
    langId,
    productId,
    storeID,
    createAt
  ) {
    const backToStep3_1 = () => {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "staffInfo",
            val: {
              ...globalState.staffInfo,
              currMealDetail: "",
              currentCheckOrderStep: "3.1",
            },
          },
        ],
      });
    };
    try {
      const res = await getSecificProduct(
        orderCode,
        langId,
        productId,
        storeID,
        createAt
      );
      const { errCode, product } = res.data;
      if (errCode == 200) {
        return product;
      } else {
        const Alert = await AsyncModel({
          title: globalState.langFile[`errorMsg.errorCode_${errCode}`],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });
        if (Alert) return backToStep3_1();
      }
    } catch (err) {
      console.error("SecificProduct error.");
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${416}`],
        confirmBtnText: globalState.langFile["popup.buttonConfirm"],
      });
      if (Alert) return backToStep3_1();
    }
  }

  // lang
  useEffect(() => {
    const handler = async () => {
      const orderCode = globalState.staffInfo.orderCode;
      const langCode = langStringToCode(globalState.langType);
      const productId = globalState.staffInfo.currMealDetail.id;
      const storeID = globalState.staffInfo.checkOrderBranch.branchCode;
      const createAt = moment(
        globalState.staffInfo.checkOrderData.orderTime
      ).format("YYYY/MM/DD");
      const getSecificProduct = await apiSecificProduct(
        orderCode,
        langCode,
        productId,
        storeID,
        createAt
      );
     
      if (getSecificProduct) {
        getSecificProduct.specification = getSecificProduct.specification.map(
          (eachSpec) => {
            if (eachSpec.combination.length <= 0) {
              // 試用模式=3 僅限外帶 預設給外帶
              eachSpec.combination = [
                {
                  takeout: eachSpec.applyMode === 3,
                  taste: (eachSpec.applyMode === 3
                    ? getSecificProduct.takeoutTaste
                    : getSecificProduct.stayInTaste
                  )
                    .filter((f) => f.preset)
                    .map((e) => e.id),
                  quantity: 0,
                },
              ];
            }
            //判斷鎖菜顯示
            if (globalState.Hold) {
              eachSpec.combination = eachSpec.combination.map((combination) => {
                const matchingItems = globalState.Hold.holditems.filter(
                  (item) =>
                    item.productIdcombi.id === eachSpec.id &&
                    item.id === combination.id &&
                    JSON.stringify(item.productIdcombi.taste) ==
                      JSON.stringify(combination.taste)
                );
                if (matchingItems.length > 0) {
                  return {
                    ...combination,
                    bIsLock: true,
                    lockTime: matchingItems[0].hold,
                  };
                }
                return combination;
              });
            }

            return eachSpec;
          }
        );
        setState((curr) => {
          return {
            ...curr,
            productData: {
              id: getSecificProduct.id,
              name: getSecificProduct.name,
              specification: getSecificProduct.specification,
              stayInTaste: getSecificProduct.stayInTaste,
              takeoutTaste: getSecificProduct.takeoutTaste,
            },
          };
        });
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            {
              key: "staffInfo",
              val: {
                ...globalState.staffInfo,
                currMealDetail: {
                  ...globalState.staffInfo.currMealDetail,
                  description: getSecificProduct.description,
                  originSpecification: _.cloneDeep(
                    getSecificProduct.specification
                  ),
                  mealTag: getSecificProduct.allergen.concat(
                    getSecificProduct.recommend
                  ),
                  name: getSecificProduct.name,
                  typeName: getSecificProduct.categoryName,
                },
              },
            },
          ],
        });
      }
    };
    handler();
  }, [globalState.langType]);

  // 處理特口、外帶狀態相同的組合要合併成同一欄
  function merge(data) {
    let deep;
    if (!data) {
      deep = _.cloneDeep(state.specificationData);
    } else {
      deep = _.cloneDeep(data);
    }
    let isEquals = (a, b) => {
      return (
        a.takeout === b.takeout &&
        a.taste.sort().toString() === b.taste.sort().toString()
      );
    };
    const { specification } = deep;
    specification.map((spec) => {
      const combin = spec.combination.reduce((current, item) => {
        const findIndex = current.findIndex((item1) => isEquals(item, item1));
        if (findIndex === -1) {
          return [...current, item];
        } else {
          const nextCurrent = current.slice(0);
          const isLimit =
            item.quantity + nextCurrent[findIndex].quantity >= 99
              ? 99
              : item.quantity + nextCurrent[findIndex].quantity;
          if (item.quantity + nextCurrent[findIndex].quantity > 99)
            AsyncModel({
              title: globalState.langFile["popup.itemLimit"],
              cancelBtnText: globalState.langFile["popup.buttonCancel"],
              confirmBtnText: globalState.langFile["popup.buttonConfirm"],
            });
          nextCurrent[findIndex] = {
            ...nextCurrent[findIndex],
            quantity: isLimit,
          };
          return nextCurrent;
        }
      }, []);
      spec.combination = combin;
    });

    let parser = deep.specification.filter((spec) => {
      return spec.combination.length !== 0;
    });
    deep.specification = parser;
    return deep;
  }
  function handlePostDate(data) {
    let newData = _.cloneDeep(data);
    newData = {
      id: newData.id,
      specification: newData.specification
        .map((eachSpec) => {
          return {
            id: eachSpec.id,
            name: eachSpec.name,
            combination: eachSpec.combination.filter(
              (eachCombi) => eachCombi.quantity > 0
            ),
          };
        })
        .filter((eachSpec) => eachSpec.combination.length > 0),
    };
    return newData.specification;
  }
  function $haveSoldOut() {
    if (state.productData) {
      return state.productData.specification.some((eachSpec) => {
        // 狀態是售畢
        return (
          eachSpec.status === 3 &&
          eachSpec.combination.some((eachCombi) => {
            // 且數量不為零
            return eachCombi.quantity > 0;
          })
        );
      });
    }
    return false;
  }
  function $atLeastOne() {
    if (state.productData) {
      return state.productData.specification.some((eachSpec) => {
        return eachSpec.combination.some((eachCombi) => {
          // 至少有一個商品大於0
          return eachCombi.quantity > 0;
        });
      });
    }
    return false;
  }
  function $haveOriginMeal() {
    if (globalState.staffInfo.currMealDetail.originSpecification) {
      let haveMeal = false;
      globalState.staffInfo.currMealDetail.originSpecification.some(
        (eachSpec) => {
          eachSpec.combination.some((eachCombi) => {
            // 至少有一個商品大於0
            if (eachCombi.quantity > 0) {
              haveMeal = true;
            }
          });
        }
      );
      return haveMeal;
    }
  }
  return (
    <div className="Pages col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0 mh-80">
      <div className="Pages__title mealInfo__title mb-3">
        {/* {globalState.staffInfo.currMealDetail.name} */}
        <DynamicFont content={globalState.staffInfo.currMealDetail.name} />
      </div>
      <div className="Pages__subtitle txtColorBrown mb-3">
        {globalState.staffInfo.currMealDetail.typeName}
      </div>
      <div className="Pages__space w-100 mb-3">
        <div className="Pages__space__item w-100  p-2 p-sm-3 text-justify"
          dangerouslySetInnerHTML={{
            __html:globalState.staffInfo.currMealDetail.description,
          }}
        ></div>
        <div className="Pages__mealsTagSpace">
          {globalState.staffInfo.currMealDetail.mealTag.map((tagItem) => (
            <div className="Pages__mealsTag p-1 mr-1 mb-1">
              <img
                style={{ height: "25px" }}
                className="mr-1"
                src={tagItem.icon}
                alt=""
              />
              <span>{tagItem.description}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="Pages__mealsDetail Pages__section d-flex flex-column align-items-center">
        <div className="Pages__section">
          {/* 特口的規格 */}
          <Tool_mealListWithoutSplit_staff
            device={globalState.device}
            data={state.productData}
            onDelete={async (newData) => {
              const alert = await AsyncModel({
                title: globalState.langFile["popup.msgDelete"],
                showCancelBtn: true,
                cancelBtnText: globalState.langFile["popup.buttonCancel"],
                confirmBtnText: globalState.langFile["popup.buttonConfirm"],
              });
              if (alert) {
                setState((curr) => {
                  let newState = { ...curr };
                  newState.productData = newData.newData;
                  return newState;
                });
              }
            }}
            onUpdate={(newData) => {
              setState((curr) => {
                let newState = { ...curr };
                newState.productData = newData;
                newState.productData = merge(newState.productData);
                return newState;
              });
            }}
            onEditTaste={(newData) => {
              setState((curr) => {
                return {
                  ...curr,
                  currModify: newData.currModify,
                  specPopupSetting: newData.specPopupSetting,
                };
              });
            }}
            onAddNewSpec={(newCurrModify) => {
              setState((curr) => {
                return {
                  ...curr,
                  isAddNew: newCurrModify.isAddNew,
                  specPopupSetting: newCurrModify.specPopupSetting,
                  currModify: newCurrModify.currModify,
                };
              });
            }}
          />
          {/* <Tool_mealListWithoutSplit
            device={globalState.device}
            data={state.productData}
            onDelete={async (newData) => {
              const alert = await AsyncModel({
                title: globalState.langFile["popup.msgDelete"],
                showCancelBtn: true,
                cancelBtnText: globalState.langFile["popup.buttonCancel"],
                confirmBtnText: globalState.langFile["popup.buttonConfirm"],
              });
              if (alert) {
                setState((curr) => {
                  let newState = { ...curr };
                  newState.productData = newData.newData;
                  return newState;
                });
              }
            }}
            onUpdate={(newData) => {
              setState((curr) => {
                let newState = { ...curr };
                newState.productData = newData;
                newState.productData = merge(newState.productData);
                return newState;
              });
            }}
            onEditTaste={(newData) => {
              setState((curr) => {
                return {
                  ...curr,
                  currModify: newData.currModify,
                  specPopupSetting: newData.specPopupSetting,
                };
              });
            }}
            onAddNewSpec={(newCurrModify) => {
              setState((curr) => {
                return {
                  ...curr,
                  isAddNew: newCurrModify.isAddNew,
                  specPopupSetting: newCurrModify.specPopupSetting,
                  currModify: newCurrModify.currModify,
                };
              });
            }}
          /> */}
        </div>
      </div>
      <div className="Pages__section d-flex justify-content-center mt-4 mb-4">
        <CusButton.White
          className="p-3 pl-sm-5 pr-sm-5 mt-2 mb-2 mr-3 col col-sm-auto"
          children={
            <FormattedMessage id="pages.staffCheckOrder.step3_2.buttonBack" />
          }
          onClick={() => {
            let gotoStep =
              globalState.staffInfo.isFromOrderDetail === true ? "3" : "3.1";
            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "staffInfo",
                  val: {
                    ...globalState.staffInfo,
                    currMealDetail: null,
                    currentCheckOrderStep: gotoStep,
                  },
                },
              ],
            });
          }}
        />
        <CusButton.Red
          className="p-3 pl-sm-5 pr-sm-5 mt-2 mb-2 ml-3 col col-sm-auto"
          children={
            <FormattedMessage
              id={`pages.staffCheckOrder.step3_2.${
                $haveSoldOut() ? "buttonHaveSoldOut" : "buttonSave"
              }`}
            />
          }
          disabled={!$haveOriginMeal() && ($haveSoldOut() || !$atLeastOne())}
          // disabled={$haveSoldOut()}
          onClick={async () => {
            const { orderCode } = globalState.staffInfo;
            const { id, name } = state.productData;
            try {
              let updateResult = await postOrderEditProduct({
                orderCode: orderCode,
                productID: id,
                name: name,
                specification: handlePostDate(state.productData),
                storeID: globalState.staffInfo.checkOrderBranch.branchCode,
                createAt: moment(
                  globalState.staffInfo.checkOrderData.orderTime
                ).format("YYYY/MM/DD"),
              });
              const { errCode } = updateResult.data;
              // console.log({
              //   orderCode: orderCode,
              //   productID: id,
              //   name: name,
              //   specification: handlePostDate(state.productData),
              //   storeID: globalState.staffInfo.checkOrderBranch.branchCode,
              //   createAt: moment(
              //     globalState.staffInfo.checkOrderData.orderTime
              //   ).format("YYYY/MM/DD"),
              // });
              if (errCode == 200) {
                let gotoStep =
                  globalState.staffInfo.isFromOrderDetail === true
                    ? "3"
                    : "3.1";
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "staffInfo",
                      val: {
                        ...globalState.staffInfo,
                        currMealDetail: null,
                        currentCheckOrderStep: gotoStep,
                      },
                    },
                  ],
                });
              } else {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [{ key: "errMsg", val: errCode }],
                });
                props.history.push("/staff/error");
              }
            } catch (err) {
              console.error("OrderEditProduct error.");
              dispatchGlobal({
                type: "UPDATE",
                payload: [{ key: "errMsg", val: 417 }],
              });
              props.history.push("/staff/error");
            }
          }}
        />
      </div>
      {/* 特口彈跳視窗 */}
      {(() => {
        if (!state.specPopupSetting.toggle) return null;
        return (
          <Tool_CusSp
            productName={state.specPopupSetting.productName}
            specName={state.specPopupSetting.specName}
            takeoutTaste={state.specPopupSetting.takeoutTaste}
            dineInTaste={state.specPopupSetting.dineInTaste}
            takeoutState={
              state.specPopupSetting.applyMode === 3
                ? true
                : state.currModify.takeout
            } // 若僅限外帶，預設給true
            disableTakeoutState={state.specPopupSetting.disableTakeoutState}
            applyModeState={state.specPopupSetting.applyMode}
            selectedItems={state.currModify.taste}
            onClose={(e) => {
              setState((curr) => {
                return {
                  ...curr,
                  currModify: null,
                  isAddNew: false,
                  specPopupSetting: {
                    toggle: false,
                    productName: "",
                    specName: "",
                    dineInTaste: [],
                    takeoutTaste: [],
                  },
                };
              });
            }}
            onSelectItem={async (e) => {
              e.taste.sort();
              let deep = _.cloneDeep(state.productData);
              let { specification } = deep;
              if (state.isAddNew) {
                let findCurrentSpec = specification.find(
                  (f) => f.id === state.currModify.specId
                );
                // takeout: 可能需要改 e.applyMode === 3
                findCurrentSpec.combination = [
                  ...findCurrentSpec.combination,
                  {
                    takeout: e.takeoutState,
                    taste: e.taste,
                    quantity: 1,
                  },
                ];
                setState((curr) => {
                  return {
                    ...curr,
                    currModify: null,
                    isAddNew: false,
                    specPopupSetting: {
                      toggle: false,
                      productName: "",
                      specName: "",
                      dineInTaste: [],
                      takeoutTaste: [],
                    },
                    productData: merge(deep),
                  };
                });
              } else {
                specification.map((_eachSp) => {
                  if (_eachSp.id === state.currModify.specId) {
                    // 找到當前要修改的combination
                    let findCurrentCombi = _eachSp.combination.find((f) => {
                      return (
                        f.takeout === state.currModify.takeout &&
                        f.taste.sort().toString() ===
                          state.currModify.taste.sort().toString() &&
                        f.quantity === state.currModify.quantity
                      );
                    });
                    // console.log(findCurrentCombi, state.currModify, e);
                    // 更新當前要修改的combination的特口
                    if (
                      findCurrentCombi.taste.sort().toString() !==
                        e.taste.sort().toString() ||
                      findCurrentCombi.takeout !== e.takeoutState
                    ) {
                      findCurrentCombi.taste = e.taste;
                      findCurrentCombi.takeout = e.takeoutState;
                      setState((curr) => {
                        return {
                          ...curr,
                          isAddNew: false,
                          currModify: null,
                          specPopupSetting: {
                            toggle: false,
                            productName: "",
                            specName: "",
                            dineInTaste: [],
                            takeoutTaste: [],
                          },
                          productData: merge(deep),
                        };
                      });
                    }
                  }
                });
              }
              const { orderCode } = globalState.staffInfo;
              const { id, name } = state.productData;
              try {
                let updateResult = await postOrderEditProduct({
                  orderCode: orderCode,
                  productID: id,
                  name: name,
                  specification: handlePostDate(state.productData),
                  storeID: globalState.staffInfo.checkOrderBranch.branchCode,
                  createAt: moment(
                    globalState.staffInfo.checkOrderData.orderTime
                  ).format("YYYY/MM/DD"),
                });
                const { errCode } = updateResult.data;
                console.log({
                  orderCode: orderCode,
                  productID: id,
                  name: name,
                  specification: handlePostDate(state.productData),
                  storeID: globalState.staffInfo.checkOrderBranch.branchCode,
                  createAt: moment(
                    globalState.staffInfo.checkOrderData.orderTime
                  ).format("YYYY/MM/DD"),
                });
              } catch (err) {
                console.error("OrderEditProduct error.");
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [{ key: "errMsg", val: 417 }],
                });
                props.history.push("/staff/error");
              }
            }}
          />
        );
      })()}
    </div>
  );
}

export default withRouter(OrderStep_3_mealInfo);
